import { render } from "./update-product.vue?vue&type=template&id=301591ae&scoped=true"
import script from "./update-product.vue?vue&type=script&lang=js"
export * from "./update-product.vue?vue&type=script&lang=js"

import "./update-product.vue?vue&type=style&index=0&id=301591ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301591ae"]])

export default __exports__